export default __webpack_public_path__ + "shopify.a677e197.png";